"use strict";

module.exports = {
  front_name: 'Aspiejob',
  back_name: 'aspie-job',
  logo: '/images/logo-aspiejob.png',
  dev_url: 'http://localhost:1007/',
  prod_url: 'https://www.aspiejob.org/',
  google_analytics: 'UA-105690626-1',
  // In development, override all email addresses
  DEV_EMAIL: 'patxi@panda-one.fr',
  admin_receiver: ['support@panda-one.fr'],
  admin_sender: 'Aspiejob <contact@aspiejob.org>',
  meta_description: 'Site de recherche d\'emploi des personnes Asperger et de mise en relation avec les employeurs.',
  meta_image: '/images/logo-aspiejob.png',
  cookies_path: 'https://www.aspiejob.org/optional_js/'
};
